var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-1/2 text-xs mx-2 passwordRulesList"},[_c('p',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.$t("Forms.your_password_must_have"))+":")]),_vm._v(" "),_c('ul',{staticClass:"list-disc ml-4"},_vm._l((_vm.passwordRules),function(item,index){return _c('li',{key:index},[_vm._v("\n            "+_vm._s(item)+"\n        ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }